import { X } from "react-feather";
import { Line } from "../../../../components/Line/styles";
import { Text, TextButton } from "../../../../components/BaseComponents/styles";
import { Colors } from "../../../../values/colors";
import { Wrapper, Chip, ChipRemove } from "./styles";

const LEVEL_LABELS = {
  businessUnit: "Unidade",
  sector: "Setor",
  subsector: "Subsetor",
};

// Remover um nível também limpa os níveis abaixo dele na hierarquia
// (Unidade de Negócio -> Setor -> Subsetor), já que deixam de fazer sentido
// sem o nível pai selecionado.
const CASCADE = {
  businessUnit: ["businessUnit", "sector", "subsector"],
  sector: ["sector", "subsector"],
  subsector: ["subsector"],
};

const LEVELS = ["businessUnit", "sector", "subsector"];

export const AppliedFiltersBar = ({ filters, onRemove, onClear }) => {
  const active = LEVELS.filter((level) => filters?.[level]);

  if (!active.length) return null;

  return (
    <Wrapper>
      <Line gap="10" wrap="wrap" alignItems="center">
        <Text size={13} weight={700} color={Colors.blueGray2}>Filtros aplicados:</Text>

        <Line gap="8" wrap="wrap" style={{ flex: 1 }}>
          {active.map((level) => (
            <Chip key={level}>
              <Text size={12} weight={600} color={Colors.primary}>
                {LEVEL_LABELS[level]} {filters[level]}
              </Text>
              <ChipRemove
                onClick={() => onRemove(CASCADE[level])}
                aria-label={`Remover filtro de ${LEVEL_LABELS[level]}`}
              >
                <X size={12} color={Colors.primary} />
              </ChipRemove>
            </Chip>
          ))}
        </Line>

        <TextButton onClick={onClear} color={Colors.primary}>
          <Text weight={700} size={13}>Limpar filtros</Text>
        </TextButton>
      </Line>
    </Wrapper>
  );
};
